import { render, staticRenderFns } from "./CustomerStockList.vue?vue&type=template&id=16a53ffe&"
import script from "./CustomerStockList.vue?vue&type=script&lang=js&"
export * from "./CustomerStockList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports